import {
  RESET_METRICS,
  METRICS_ERROR,
  GET_METRICS,
  SET_METRICS,
  UPDATE_METRIC,
} from "./actionTypes";

const initialState = {
  data: {},
  status: {
    loading: false,
    error: false,
    success: false,
  },
};

const metricsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_METRICS:
      return {
        ...initialState,
      };
    case METRICS_ERROR:
      return {
        ...state,
        status: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case GET_METRICS: {
      return {
        ...state,
        status: {
          loading: true,
          error: false,
          success: false,
        },
      };
    }
    case SET_METRICS: {
      return {
        ...state,
        data: action.payload,
        status: {
            loading: false,
            error: false,
            success: true,
        },
      };
    }
    case UPDATE_METRIC: {
      return {
        ...state,
        data: {
          ...state.data,
          status:{
            ...state.data.status,
            start_time: action.payload,
          }
        }
      }
    }
      break;
    default:
      return state;
  }
};

export default metricsReducer;
